export enum HttpMethod {
    GET    = 'get',
    POST   = 'post',
    DELETE = 'delete',
    PUT    = 'put',
}
